// LinkedinUrlSourceForm — US-127 (URL field for LinkedIn Search).

import { useT } from '@barel/i18n';
import { FieldAssembly, Input } from '@barel/ui';

import { isValidCampaignSearchUrl } from '../lib/sourceUrl';

export interface LinkedinUrlSourceFormProps {
  value: string;
  onChange: (next: string) => void;
}

export function LinkedinUrlSourceForm({ value, onChange }: LinkedinUrlSourceFormProps) {
  const t = useT('campaigns');
  const label = t('source.linkedin') as string;
  const invalid = value.trim().length > 0 && !isValidCampaignSearchUrl(value, 'linkedin');
  return (
    <FieldAssembly
      label={t('create.sectionSource.urlLabel', { label })}
      hint={t('create.sectionSource.urlHelp')}
      error={invalid ? t('create.sectionSource.invalidLinkedinUrl') : undefined}
    >
      <Input
        type="url"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('create.sectionSource.urlPlaceholderLi') as string}
        data-testid="campaign-source-url"
      />
    </FieldAssembly>
  );
}
